export class IGrowthRatesSave{
    message: string;
    constructor ( message: string){
        this.message = message;
    }
}


/** WEBPACK FOOTER **
 ** ./app/system-management/growth-rates/growth-rates-save/growth-rates-save.ts
 **/